import {
  Activity,
  FileChartColumnIncreasing,
  MessageCircleMore,
  TrendingUp,
} from 'lucide-react';
import type { ReactNode } from 'react';

import { SCHEDULE_PERIOD } from './commonConst';

export enum WORKFLOW_TYPE {
  REALTIME = 1,
  PERIODIC = 2,
  SUBSCRIPTION = 3,
  SIGNAL_ALERT = 4,
}

export const WorkflowTypeDic: Record<WORKFLOW_TYPE, string> = {
  [WORKFLOW_TYPE.REALTIME]: 'Real-time',
  [WORKFLOW_TYPE.PERIODIC]: 'Schedule',
  [WORKFLOW_TYPE.SUBSCRIPTION]: 'Subscription',
  [WORKFLOW_TYPE.SIGNAL_ALERT]: 'Signal alert',
};

export enum WORKFLOW_REALTIME_BASIS {
  EVERY = 1,
  SELECTED_FILTER,
}

export const WorkspaceRealtimeOptionDic: Record<
  WORKFLOW_REALTIME_BASIS,
  string
> = {
  [WORKFLOW_REALTIME_BASIS.EVERY]: 'Every feedback',
  [WORKFLOW_REALTIME_BASIS.SELECTED_FILTER]: 'Selected filter',
};

export const realtimeBasisOptions = [
  WORKFLOW_REALTIME_BASIS.SELECTED_FILTER,
  WORKFLOW_REALTIME_BASIS.EVERY,
];

export const PeriodicComparerDic: Record<SCHEDULE_PERIOD, string> = {
  [SCHEDULE_PERIOD.DAILY]: 'Day to Day',
  [SCHEDULE_PERIOD.WEEKLY]: 'Week to Week',
  [SCHEDULE_PERIOD.MONTHLY]: 'Month to Month',
};

export enum WORKFLOW_PERIODIC_BASIS {
  FEEDBACK = 1,
  TOPIC = 2,
  //SOURCE = 3,
  TAG = 4,
  REMARKS = 5,
  DATA_ORIGIN = 6,
}

export const WorkflowPeriodicBasisDic: Record<WORKFLOW_PERIODIC_BASIS, string> =
  {
    [WORKFLOW_PERIODIC_BASIS.FEEDBACK]: 'Feedback',
    [WORKFLOW_PERIODIC_BASIS.TOPIC]: 'Topics',
    // [WORKFLOW_PERIODIC_BASIS.SOURCE]: 'Sources',
    [WORKFLOW_PERIODIC_BASIS.TAG]: 'Tags',
    [WORKFLOW_PERIODIC_BASIS.REMARKS]: 'Remarks',
    [WORKFLOW_PERIODIC_BASIS.DATA_ORIGIN]: 'Data origins',
  };

export enum WORKFLOW_COMPARE_DELTA {
  INCREASE = 1,
  DECREASE,
}

export const WorkflowiCompareDeltaDic: Record<WORKFLOW_COMPARE_DELTA, string> =
  {
    [WORKFLOW_COMPARE_DELTA.INCREASE]: 'Up',
    [WORKFLOW_COMPARE_DELTA.DECREASE]: 'Down',
  };

export enum WORKFLOW_PERIODIC_TRIGGER_TYPE {
  NUMERICAL = 'Absolute number',
  PERCENTAGE = 'Percent',
}

export enum WORKFLOW_SUBSCRIPTION_BASIS {
  // DASHBOARD = 1,
  DASHBOARD2 = 2,
}

export const WorkflowSubscriptionBasisDic: Record<
  WORKFLOW_SUBSCRIPTION_BASIS,
  string
> = {
  [WORKFLOW_SUBSCRIPTION_BASIS.DASHBOARD2]: 'Dashboard2',
};

export enum WORKFLOW_SUBSCRIPTION_PERIOD {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
}

export const WorkflowSubscriptionPeriodDic: Record<
  WORKFLOW_SUBSCRIPTION_PERIOD,
  string
> = {
  [WORKFLOW_SUBSCRIPTION_PERIOD.DAILY]: 'Daily',
  [WORKFLOW_SUBSCRIPTION_PERIOD.WEEKLY]: 'Weekly',
  [WORKFLOW_SUBSCRIPTION_PERIOD.MONTHLY]: 'Monthly',
};

export const WorkflowIconMap: Record<WORKFLOW_TYPE, ReactNode> = {
  [WORKFLOW_TYPE.REALTIME]: <MessageCircleMore className="size-4" />,
  [WORKFLOW_TYPE.PERIODIC]: <TrendingUp className="size-4" />,
  [WORKFLOW_TYPE.SUBSCRIPTION]: (
    <FileChartColumnIncreasing className="size-4" />
  ),
  [WORKFLOW_TYPE.SIGNAL_ALERT]: <Activity className="size-4" />,
};

export const MAX_WORKFLOW_COUNT = 5;

export enum WORKFLOW_CHANNEL_TYPE {
  SLACK = 'SLACK',
  MAIL = 'MAIL',
}

export enum WORKFLOW_SIGNAL_ALERT_BASIS {
  AUTO = 'AUTO',
  CUSTOM = 'CUSTOM',
}
